
import React, { useState, useEffect, useRef } from 'react';
import {
  LayoutDashboard,
  DollarSign,
  Users,
  CheckSquare,
  Briefcase,
  Settings,
  Menu,
  Bell,
  Search,
  Zap,
  GraduationCap,
  X,
  LogOut,
  User,
  PieChart,
  ChevronDown,
  Trophy,
  Wallet,
  Calendar,
  Send,
  RefreshCw,
  Megaphone,
  KanbanSquare,
  Map as MapIcon,
  Route as RouteIcon,
  BarChart3,
  Plus,
  ArrowRight,
  CreditCard,
  AlertTriangle,
  Bug,
  HeartHandshake,
  MessageSquare,
  XCircle,
  Gavel,
  Layers,
  ClipboardCheck,
  Inbox,
  TrendingUp,
  LifeBuoy,
  Workflow,
  Plug,
  Activity,
  Sparkles,
  BarChart2,
  Gift,
  Wrench,
  Fingerprint
} from 'lucide-react';
import { HashRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './src/contexts/AuthContext';
import RoleGuard from './src/components/RoleGuard';
import { ehGerenteComercial, temDepartamento } from './src/lib/departamentos';

// #6518: o único vendedor que entra na Central de Solicitações é o do Comercial (antigo Comercial Interno).
const vendedorComercialInterno = (p: { role?: string | null; departamento?: string | null; departamentos?: string[] | null } | null | undefined): boolean =>
  p?.role === 'vendedor' && temDepartamento(p as any, 'Comercial');
import { MOSTRAR_ITENS_V2_EM_DISCUSSAO } from './src/lib/politicaComercial';
import { podeUsarIndicacoes } from './src/lib/indicacoes/permissoes';
import { hasLemitAccess } from './src/lib/lemitAcesso';
import { podeTrabalharRemarketing } from './src/lib/remarketing';
import { GERAR_ROTA_TERCEIROS_PERMISSION } from './views/CRM/Rotas/rotaTypes';
import { ToastProvider } from './src/contexts/ToastContext';
import { resolverModuloDaRota } from './src/lib/usoRotas';
import { logUsageEvent } from './src/lib/logger';
import ProtectedRoute from './src/components/ProtectedRoute';
import MaintenanceGate from './src/components/MaintenanceGate';
import NotificationDropdown from './src/components/NotificationDropdown';
import TermoReprovadoPopup from './src/components/TermoReprovadoPopup';
import AprovacaoDescontoPopup from './src/components/AprovacaoDescontoPopup';
import TermoAssinadoPopup from './src/components/TermoAssinadoPopup';
import LeadAssignedPopup from './src/components/LeadAssignedPopup';
import AcordoPublicoView from './views/AcordoPublico/AcordoPublicoView';
import InadimplenciaDashboard from './views/CRM/Inadimplencia';
import ThemeToggle from './src/components/ThemeToggle';
import PausaSlaToggle from './src/components/PausaSlaToggle';
import LoginView from './views/LoginView';
import VisaoGeralView from './views/VisaoGeral/VisaoGeralView';
import DashboardLayout from './views/Dashboard/DashboardLayout';
import GestaoLayout from './views/Gestao/GestaoLayout';
import { ExtracaoFaturasProvider } from './views/Gestao/ExtracaoFaturasContext';
import FinanceiroLayout from './views/Financeiro/FinanceiroLayout';
import CRMLayout from './views/CRM/CRMLayout';
import TarefasView from './views/Tarefas/TarefasView';
import ProjetosView from './views/Projetos/ProjetosView';
import ProjetoDetailView from './views/Projetos/ProjetoDetailView';
import SolicitacaoModalGlobal from './views/Tarefas/SolicitacaoModalGlobal';
import AvisoPrazoSolicitacoes from './views/Tarefas/AvisoPrazoSolicitacoes';
import AvisosSolicitacao from './views/Tarefas/AvisosSolicitacao';
import ConfigView from './views/ConfigView';
import GeradorasView from './views/Geradoras/GeradorasView';
import AcademyView from './views/Academy/AcademyView';
import ApresentacaoView from './views/ApresentacaoView';
import ManualConsumidorView from './views/ManualConsumidorView';
import CadastroConsultorView from './views/CadastroConsultor/CadastroConsultorView';
import LinkParceiroView from './views/LinkParceiro/LinkParceiroView';
import PortalConsumidorView from './views/PortalConsumidor/PortalConsumidorView';
import PortalConsumidorHome from './views/PortalConsumidor/PortalConsumidorHome';
import PortalConsumidorNovaSenha from './views/PortalConsumidor/PortalConsumidorNovaSenha';
import PortalConsumidorPerfil from './views/PortalConsumidor/PortalConsumidorPerfil';
import PortalConsumidorFaturas from './views/PortalConsumidor/PortalConsumidorFaturas';
import PortalConsumidorParcelamentos from './views/PortalConsumidor/PortalConsumidorParcelamentos';
import PortalConsumidorAjuda from './views/PortalConsumidor/PortalConsumidorAjuda';
import PortalConsumidorCancelamento from './views/PortalConsumidor/PortalConsumidorCancelamento';
import PortalConsumidorRetencao from './views/PortalConsumidor/PortalConsumidorRetencao';
import PortalConsumidorGate from './views/PortalConsumidor/PortalConsumidorGate';
import { MarcaPortalLayout } from './views/PortalConsumidor/marca/MarcaPortalContext';
import AvisosSistemaGate from './src/components/AvisosSistemaGate';
import MarketingLayout from './views/Marketing/MarketingLayout';
import VickLauncherButton from './src/components/Vick/VickLauncherButton';
import VickView from './views/Vick/VickView';
import FerramentasLayout from './views/Ferramentas/FerramentasLayout';
import OmnichannelView from './views/Omnichannel/OmnichannelView';
import InboxView from './views/Omnichannel/Inbox/InboxView';
import InboxConfiguracoesView from './views/Omnichannel/Inbox/ConfiguracoesView';
import InboxEventosView from './views/Omnichannel/Inbox/EventosView';
import InboxAtendimentoView from './views/Omnichannel/Inbox/AtendimentoView';
import FluxosView from './views/Omnichannel/Fluxos/FluxosView';
import EditorFluxoView from './views/Omnichannel/Fluxos/EditorFluxoView';
import { useInboxMembro } from './src/hooks/useInboxMembro';
import ComposerTesteView from './views/Omnichannel/ComposerTesteView';

/** Consumidor do portal (role mais básico) nunca navega no hub interno — sempre volta pra área dele. */
const ConsumidorPortalGate = ({ children }: { children: React.ReactNode }) => {
  const { profile } = useAuth();
  if (profile?.role === 'consumidor') return <Navigate to="/portal-consumidor/inicio" replace />;
  return <>{children}</>;
};

/** Monitor externo de geradoras: só enxerga /geradoras — qualquer outra rota volta pra lá. */
const ExternoGeradorasGate = ({ children }: { children: React.ReactNode }) => {
  const { profile } = useAuth();
  const location = useLocation();
  if (profile?.role === 'geradoras_externo' && !location.pathname.startsWith('/geradoras')) {
    return <Navigate to="/geradoras" replace />;
  }
  return <>{children}</>;
};

const NavItem = ({
  to,
  label,
  active,
  onClick
}: {
  to: string,
  label: string,
  active: boolean,
  onClick?: () => void
}) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${active
        ? 'bg-primary/90 text-white shadow-sm'
        : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700'
        }`}
    >
      {label}
    </Link>
  );
};

const DropdownNavItem = ({
  label,
  active,
  items
}: {
  label: string,
  active: boolean,
  items: { label: string, to?: string, onClick?: () => void }[]
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 150); // slight delay to prevent flickering
  };

  return (
    <div
      className="relative inline-block text-left"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className={`inline-flex items-center gap-1 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${active
          ? 'bg-primary/90 text-white shadow-sm'
          : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700'
          }`}
      >
        {label}
        <ChevronDown size={14} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div
          className="absolute z-50 mt-1 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none"
        // Adding a small invisible bridge so the mouse doesn't leave the component area when moving down to the dropdown
        >
          <div className="py-1" role="menu" aria-orientation="vertical">
            {items.map((item, index) => item.to ? (
              <Link
                key={index}
                to={item.to}
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                role="menuitem"
              >
                {item.label}
              </Link>
            ) : (
              <button
                key={index}
                type="button"
                onClick={() => { item.onClick?.(); setIsOpen(false); }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                role="menuitem"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const MobileNavItem = ({
  to,
  icon: Icon,
  label,
  active,
  onClick
}: {
  to?: string,
  icon: any,
  label: string,
  active: boolean,
  onClick?: () => void
}) => {
  const className = `flex items-center gap-3 px-3 py-2 rounded-md text-base font-medium w-full text-left ${active
    ? 'bg-primary/10 text-primary dark:bg-primary/20'
    : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'
    }`;

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={className}>
        <Icon size={20} />
        {label}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      <Icon size={20} />
      {label}
    </button>
  );
};

/**
 * Módulo do menu mobile com 2+ telas: o cabeçalho é o nome do módulo (ex.: "Financeiro"),
 * clicável, e as telas só aparecem expandidas — sem isso o drawer vira uma lista de ~25
 * itens soltos (era o caso antes desta mudança). Comporta-se como acordeão: abrir um
 * módulo fecha o anterior (estado mora em MainLayout, ver `openMobileGroup`), porque o
 * ponto é reduzir rolagem, não empilhar todo mundo aberto.
 *
 * Um módulo com uma única tela (ex.: Geradoras) não passa por aqui — continua
 * `MobileNavItem` normal, linkando direto. Ver `renderMobileModule` mais abaixo.
 */
const MobileNavGroup = ({
  icon: Icon,
  label,
  active,
  isOpen,
  onToggle,
  items
}: {
  icon: any,
  label: string,
  active: boolean,
  isOpen: boolean,
  onToggle: () => void,
  items: { to?: string, icon: any, label: string, active: boolean, onClick?: () => void }[]
}) => {
  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className={`flex items-center gap-3 px-3 py-2 rounded-md text-base font-medium w-full text-left transition-colors ${active
          ? 'text-primary dark:text-primary'
          : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'
          }`}
      >
        <Icon size={20} />
        <span className="flex-1">{label}</span>
        <ChevronDown size={16} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="mt-1 ml-4 pl-3 border-l-2 border-gray-100 dark:border-gray-700 space-y-1">
          {items.map((item, index) => (
            <MobileNavItem
              key={index}
              to={item.to}
              icon={item.icon}
              label={item.label}
              active={item.active}
              onClick={item.onClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// Fixed: Added optional children to the props type to resolve the 'missing children' error in some TypeScript environments
const MainLayout = ({ children }: { children?: React.ReactNode }) => {
  const { user, profile, signOut } = useAuth();
  const { ehMembro: ehMembroInbox, papel: papelInbox } = useInboxMembro(profile?.id);
  // #6530: a gerente do Comercial consulta Painel Executivo e Validação de Dados.
  const gerenteComercial = ehGerenteComercial(profile);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Acordeão do menu mobile: qual módulo está expandido (null = todos fechados).
  // Um só por vez — abrir outro fecha o anterior, ver MobileNavGroup.
  const [openMobileGroup, setOpenMobileGroup] = useState<string | null>(null);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [showInadimplenciaDashboard, setShowInadimplenciaDashboard] = useState(false);
  const [inadimplenciaInitialTab, setInadimplenciaInitialTab] = useState<string | undefined>(undefined);
  const profileDropdownRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  // Permite que outras partes do app (ex.: clique numa notificação de cobrança) abram
  // a Central de Inadimplência diretamente numa aba específica.
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setInadimplenciaInitialTab(detail?.tab || 'vencidas15');
      setShowInadimplenciaDashboard(true);
    };
    window.addEventListener('vigorhub:open-inadimplencia', handler);
    return () => window.removeEventListener('vigorhub:open-inadimplencia', handler);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target as Node)) {
        setProfileDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isPathActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const isEmpresaParceira = profile?.role === 'empresa_parceira_admin' || profile?.role === 'empresa_parceira_operador';
  // Monitor externo de geradoras: nav mostra apenas o módulo Geradoras
  const isExternoGeradoras = profile?.role === 'geradoras_externo';
  // Parceiro/vendedor_parceiro: atalho fixo no mobile pra Perfil e Dados Bancarios
  const isParceiroOrVendedorParceiro = profile?.role === 'parceiro' || profile?.role === 'vendedor_parceiro';
  // Prospecção Geo consome API paga — mesma régua de CRMLayout.tsx (canProspect)
  const podeProspectar = profile?.role === 'adm' || profile?.role === 'gerente'
    || !!profile?.permissions?.includes(GERAR_ROTA_TERCEIROS_PERMISSION);
  // Gestão e Vick dividem o mesmo menu, mas têm alcances diferentes — nomeados aqui porque o
  // dropdown precisa dos dois separados pra decidir cada item (ver comentário no menu).
  const podeVerGestao = !isEmpresaParceira && !isExternoGeradoras && (
    (profile?.role !== 'vendedor' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro' && profile?.role !== 'gerente_parcerias' && profile?.role !== 'gerente' && profile?.role !== 'motoboy') ||
    !!profile?.permissions?.includes('modulo:gestao') || gerenteComercial
  );
  const podeVerPainelExecutivo = profile?.role === 'adm' || gerenteComercial;
  // Vick: lista de permissão, não de bloqueio — ela lê a operação inteira, então papel novo
  // entra sem acesso. Espelha ROLES_COM_VICK em supabase/functions/_shared/vickCatalogo/tipos.ts,
  // que é quem decide de verdade (a edge function responde 403). Mexeu aqui, mexa lá.
  const podeVerVick = profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista';
  // Ferramentas (utilitários como o Dividir PDF): mesmo trio da Vick, mas regra própria — são
  // telas sem relação entre si, e ampliar uma não pode ampliar a outra sem querer. A rota usa
  // a mesma lista (RoleGuard `allowed`, mais abaixo).
  const podeVerFerramentas = profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista';

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setOpenMobileGroup(null);
    // Tela nova começa do topo: sem isso o celular abria a próxima tela na altura
    // em que a anterior estava rolada (#6140).
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Telemetria de uso (aba Config > Uso): cada rota "estável" vira 1 evento
  // em usage_events. Debounce de 150ms: rotas que redirecionam sozinhas
  // (ex.: <Navigate> bloqueando motoboy/parceiro em sub-rotas do CRM,
  // ver CRMLayout.tsx) commitam a rota errada por um instante antes do
  // redirect assumir — sem esse delay, essa rota intermediária vira um
  // evento falso. O cleanup cancela o timer anterior sempre que o pathname
  // muda de novo antes de disparar, então uma cadeia de redirects só loga
  // o destino final.
  useEffect(() => {
    const timer = setTimeout(() => {
      const resolvido = resolverModuloDaRota(location.pathname);
      if (resolvido) {
        logUsageEvent({
          userId: user?.id,
          modulo: resolvido.modulo,
          funcionalidade: resolvido.funcionalidade,
          acao: null,
          origem: 'navegacao',
        });
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname, user?.id]);

  // Monta cada item do menu mobile como { to, icon, label, active }. Quem decide
  // se vira um link direto ou um módulo expansível é `renderMobileModule`, pelo
  // tamanho do array — nenhuma tela aqui embaixo sabe se está agrupada ou não.
  type MobileNavEntry = { to?: string; icon: any; label: string; active: boolean; onClick?: () => void };

  const podeVerMarketing = profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista' || !!profile?.permissions?.includes('modulo:marketing');
  const podeVerFinanceiro = !isExternoGeradoras && (isEmpresaParceira || (profile?.role !== 'vendedor' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro' && profile?.role !== 'gerente_parcerias' && profile?.role !== 'motoboy'));
  const podeVerProjetosTarefas = !isEmpresaParceira && !isExternoGeradoras && profile?.role !== 'vendedor' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro';
  const podeVerGeradoras = profile?.role === 'adm' || profile?.role === 'gerente' || !!profile?.permissions?.includes('modulo:geradoras');
  // Academy no menu só para quem o Minicurso do Parceiro serve: os parceiros e quem cuida
  // deles. A rota /academy continua aberta aos demais por link direto.
  const podeVerAcademy = ['adm', 'gerente', 'gerente_parcerias', 'parceiro', 'vendedor_parceiro'].includes(profile?.role ?? '');
  const rolesFinanceiroGestao = profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista';

  const mobileDashboardItems: MobileNavEntry[] = !isExternoGeradoras ? [
    { to: '/', icon: LayoutDashboard, label: profile?.role === 'adm' ? 'Visão Geral' : 'Dashboard', active: isPathActive('/') },
    ...(podeVerPainelExecutivo ? [{ to: '/dashboard/painel-executivo', icon: PieChart, label: 'Painel Executivo', active: isPathActive('/dashboard') }] : []),
  ] : [];

  const mobileMarketingItems: MobileNavEntry[] = podeVerMarketing ? [
    { to: '/marketing/campanhas', icon: BarChart2, label: 'Campanhas', active: isPathActive('/marketing/campanhas') },
    { to: '/marketing/criativos', icon: Sparkles, label: 'Criativos', active: isPathActive('/marketing/criativos') },
  ] : [];

  const mobileCrmItems: MobileNavEntry[] = (!isEmpresaParceira && !isExternoGeradoras) ? [
    ...(profile?.role !== 'motoboy' ? [{ to: '/crm', icon: KanbanSquare, label: 'Kanban', active: location.pathname === '/crm' || location.pathname === '/crm/' }] : []),
    ...(profile?.role !== 'motoboy' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro' ? [{ to: '/crm/mapa', icon: MapIcon, label: 'Mapa Inteligente', active: isPathActive('/crm/mapa') }] : []),
    ...(podeProspectar ? [{ to: '/crm/prospeccao', icon: Search, label: 'Prospecção Geo', active: isPathActive('/crm/prospeccao') }] : []),
    // Remarketing de perdidos (#6419): a BDR trabalha, gerente e adm acompanham.
    ...(podeTrabalharRemarketing(profile) ? [{ to: '/crm/remarketing', icon: Megaphone, label: 'Remarketing', active: isPathActive('/crm/remarketing') }] : []),
    { to: '/crm/rotas', icon: RouteIcon, label: 'Rotas', active: isPathActive('/crm/rotas') },
    ...((profile?.role === 'adm' || profile?.role === 'gerente') ? [{ to: '/crm/pos-venda', icon: HeartHandshake, label: 'Pós-venda', active: isPathActive('/crm/pos-venda') }] : []),
    ...(podeUsarIndicacoes(profile) ? [{ to: '/crm/indicacoes', icon: Gift, label: 'Indicações', active: isPathActive('/crm/indicacoes') }] : []),
    // Central Lemit também no CRM: o Comercial (Hunter e BDR têm papel vendedor) não entra no módulo Gestão.
    ...(hasLemitAccess(profile) ? [{ to: '/crm/lemit', icon: Fingerprint, label: 'Central Lemit', active: isPathActive('/crm/lemit') }] : []),
    ...(profile?.role !== 'motoboy' ? [{ to: '/crm/analytics', icon: BarChart3, label: 'Analytics', active: isPathActive('/crm/analytics') }] : []),
    ...((profile?.role === 'adm' || profile?.role === 'gerente' || ehMembroInbox) ? [{ to: '/crm/analise-conversas', icon: Sparkles, label: 'Análise das conversas', active: isPathActive('/crm/analise-conversas') }] : []),
    ...(profile?.role === 'vendedor' && MOSTRAR_ITENS_V2_EM_DISCUSSAO ? [{ to: '/crm/minha-comissao', icon: Wallet, label: 'Minha Comissão', active: isPathActive('/crm/minha-comissao') }] : []),
  ] : [];

  const mobileGestaoItems: MobileNavEntry[] = [
    ...(podeVerGestao ? [{ to: '/gestao', icon: PieChart, label: 'Visão Geral', active: isPathActive('/gestao') }] : []),
    ...(podeVerVick ? [{ to: '/vick', icon: Sparkles, label: 'Vick', active: isPathActive('/vick') }] : []),
    ...(podeVerFerramentas ? [{ to: '/ferramentas', icon: Wrench, label: 'Ferramentas', active: isPathActive('/ferramentas') }] : []),
  ];

  const mobileProjetosTarefasItems: MobileNavEntry[] = podeVerProjetosTarefas ? [
    { to: '/projetos', icon: Briefcase, label: 'Projetos', active: isPathActive('/projetos') },
    { to: '/tarefas', icon: CheckSquare, label: 'Atividades e Visitas (CRM)', active: location.pathname === '/tarefas' },
    ...(profile?.role !== 'motoboy' ? [{ to: '/tarefas/solicitacoes', icon: Bug, label: 'Central de Solicitações', active: isPathActive('/tarefas/solicitacoes') }] : []),
  ] : vendedorComercialInterno(profile) ? [
    { to: '/tarefas/solicitacoes', icon: Bug, label: 'Central de Solicitações', active: isPathActive('/tarefas/solicitacoes') },
  ] : [];

  const mobileFinanceiroItems: MobileNavEntry[] = podeVerFinanceiro ? [
    { to: '/financeiro', icon: DollarSign, label: 'Dashboard', active: location.pathname === '/financeiro' },
    ...(profile?.role === 'adm' ? [{ to: '/financeiro/painel-executivo', icon: PieChart, label: 'Painel Executivo', active: isPathActive('/financeiro/painel-executivo') }] : []),
    { to: '/financeiro/ucs', icon: Users, label: 'UCs / Clientes', active: isPathActive('/financeiro/ucs') },
    { to: '/financeiro/faturas', icon: CheckSquare, label: 'Faturas e Cobranças', active: isPathActive('/financeiro/faturas') },
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/conferencia-faturamento', icon: ClipboardCheck, label: 'Conferência do Faturamento', active: isPathActive('/financeiro/conferencia-faturamento') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/recebimento-faturas', icon: Inbox, label: 'Recebimento de Faturas', active: isPathActive('/financeiro/recebimento-faturas') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/agrupamentos-faturamento', icon: Layers, label: 'Agrupamentos de Faturamento', active: isPathActive('/financeiro/agrupamentos-faturamento') }] : []),
    { to: '/financeiro/parcelamentos', icon: Calendar, label: 'Parcelamentos', active: isPathActive('/financeiro/parcelamentos') },
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/previsao-recebiveis', icon: TrendingUp, label: 'Previsão de Recebíveis', active: isPathActive('/financeiro/previsao-recebiveis') }] : []),
    /* Folha de Pagamento oculta do menu a pedido — a rota /financeiro/folha-pagamento
       continua ativa e acessível por link direto. Para trazer de volta, descomente a linha abaixo. */
    // ...(rolesFinanceiroGestao ? [{ to: '/financeiro/folha-pagamento', icon: Wallet, label: 'Folha de Pagamento', active: isPathActive('/financeiro/folha-pagamento') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/lembretes-cobranca', icon: Send, label: 'Lembretes de Cobrança', active: isPathActive('/financeiro/lembretes-cobranca') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/rota-cobranca', icon: RouteIcon, label: 'Rota de Cobrança', active: isPathActive('/financeiro/rota-cobranca') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/esteira', icon: Gavel, label: 'Painel de Cobrança e Documentos', active: isPathActive('/financeiro/esteira') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/sincronizacao-status', icon: RefreshCw, label: 'Sincronização de Status', active: isPathActive('/financeiro/sincronizacao-status') }] : []),
    ...(rolesFinanceiroGestao ? [{ to: '/financeiro/cancelamentos', icon: XCircle, label: 'Cancelamentos', active: isPathActive('/financeiro/cancelamentos') }] : []),
    {
      icon: AlertTriangle, label: 'Inadimplência', active: false,
      onClick: () => { setInadimplenciaInitialTab(undefined); setShowInadimplenciaDashboard(true); setMobileMenuOpen(false); },
    },
  ] : [];

  const mobileOmnichannelItems: MobileNavEntry[] = ehMembroInbox ? [
    { to: '/inbox', icon: MessageSquare, label: 'Caixa de entrada', active: isPathActive('/inbox') },
    { to: '/inbox/configuracoes', icon: Plug, label: 'Conexões', active: isPathActive('/inbox/configuracoes') },
    { to: '/inbox/atendimento', icon: LifeBuoy, label: 'Atendimento', active: isPathActive('/inbox/atendimento') },
    { to: '/inbox/fluxos', icon: Workflow, label: 'Automação', active: isPathActive('/inbox/fluxos') },
    { to: '/inbox/eventos', icon: Activity, label: 'Integrações', active: isPathActive('/inbox/eventos') },
    { to: '/omnichannel', icon: BarChart3, label: 'Acompanhamento', active: isPathActive('/omnichannel') },
  ].filter(i => papelInbox !== 'observador' || i.to === '/inbox' || i.to === '/inbox/atendimento') : [];

  // Decide entre link direto (1 tela) e módulo expansível (2+): ver comentário do
  // MobileNavGroup. `key` é o identificador do acordeão — precisa ser estável e
  // único entre os módulos para abrir/fechar o certo.
  const renderMobileModule = (key: string, moduloIcon: any, moduloLabel: string, items: MobileNavEntry[]) => {
    if (items.length === 0) return null;
    if (items.length === 1) {
      const unico = items[0];
      // Só o nome do módulo quando a única tela É o módulo (ex.: "Dashboard").
      // Quando a tela restante é outra coisa (ex.: só sobrou "Vick" dentro de
      // "Gestão", pra quem tem Vick sem o módulo Gestão), compõe os dois nomes —
      // senão o link mostra "Gestão" apontando pra /vick, o que é enganoso.
      const rotulo = unico.label === moduloLabel ? moduloLabel : `${moduloLabel} - ${unico.label}`;
      return <MobileNavItem to={unico.to} icon={moduloIcon} label={rotulo} active={unico.active} onClick={unico.onClick} />;
    }
    return (
      <MobileNavGroup
        icon={moduloIcon}
        label={moduloLabel}
        active={items.some(i => i.active)}
        isOpen={openMobileGroup === key}
        onToggle={() => setOpenMobileGroup(prev => (prev === key ? null : key))}
        items={items}
      />
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 fixed w-full top-0 z-50 transition-colors duration-300">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            {/* Logo Section - Left */}
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <img src="/vigorhub_logo_transparent.png" alt="VigorHub Logo" className="h-10 object-contain" />
              </div>
            </div>

            {/* Navigation Links - Center (Desktop).
                Breakpoint lg (não md): com todos os módulos o nav precisa de ~1040px —
                entre 768 e 1024px ele estourava para fora da tela sem hambúrguer
                (sintoma do Bruno: zoom maior no celular "some" com o menu do CRM). */}
            <div className="hidden lg:flex lg:space-x-1 lg:items-center">
              {!isExternoGeradoras && (
                podeVerPainelExecutivo ? (
                  <DropdownNavItem
                    label="Dashboard"
                    active={isPathActive('/') || isPathActive('/dashboard')}
                    items={[
                      { label: 'Visão Geral', to: '/' },
                      { label: 'Painel Executivo', to: '/dashboard/painel-executivo' },
                    ]}
                  />
                ) : (
                  <NavItem to="/" label="Dashboard" active={isPathActive('/')} />
                )
              )}
              {(profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista' || profile?.permissions?.includes('modulo:marketing')) && (
                <DropdownNavItem
                  label="Marketing"
                  active={isPathActive('/marketing')}
                  items={[
                    { label: 'Campanhas', to: '/marketing/campanhas' },
                    { label: 'Criativos', to: '/marketing/criativos' },
                  ]}
                />
              )}
              {!isEmpresaParceira && !isExternoGeradoras && (
                <DropdownNavItem
                  label="CRM"
                  active={isPathActive('/crm')}
                  items={[
                    ...(!(profile?.role === 'motoboy') ? [{ label: 'Kanban', to: '/crm' }] : []),
                    ...(!(profile?.role === 'motoboy') && !(profile?.role === 'parceiro' || profile?.role === 'vendedor_parceiro') ? [{ label: 'Mapa Inteligente', to: '/crm/mapa' }] : []),
                    ...(podeProspectar ? [{ label: 'Prospecção Geo', to: '/crm/prospeccao' }] : []),
                    ...(podeTrabalharRemarketing(profile) ? [{ label: 'Remarketing', to: '/crm/remarketing' }] : []),
                    { label: 'Rotas', to: '/crm/rotas' },
                    ...((profile?.role === 'adm' || profile?.role === 'gerente') ? [{ label: 'Pós-venda', to: '/crm/pos-venda' }] : []),
                    ...(podeUsarIndicacoes(profile) ? [{ label: 'Indicações', to: '/crm/indicacoes' }] : []),
                    ...(hasLemitAccess(profile) ? [{ label: 'Central Lemit', to: '/crm/lemit' }] : []),
                    ...(!(profile?.role === 'motoboy') ? [{ label: 'Analytics', to: '/crm/analytics' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || ehMembroInbox) ? [{ label: 'Análise das conversas', to: '/crm/analise-conversas' }] : []),
                    ...(profile?.role === 'vendedor' && MOSTRAR_ITENS_V2_EM_DISCUSSAO ? [{ label: 'Minha Comissão', to: '/crm/minha-comissao' }] : [])
                  ]}
                />
              )}
              {/* Vick mora dentro de Gestão, mas alcança mais gente do que ela (gerente, vendedor
                  e motoboy veem Vick e não veem Gestão). Por isso o menu abre quando qualquer um
                  dos dois é permitido, e cada item entra pela sua própria regra — senão aninhar o
                  Vick aqui tiraria o acesso dele de quem já tinha. */}
              {(podeVerGestao || podeVerVick || podeVerFerramentas) && (
                <DropdownNavItem
                  label="Gestão"
                  active={isPathActive('/gestao') || isPathActive('/vick') || isPathActive('/ferramentas')}
                  items={[
                    ...(podeVerGestao ? [{ label: 'Visão Geral', to: '/gestao' }] : []),
                    ...(podeVerVick ? [{ label: 'Vick', to: '/vick' }] : []),
                    ...(podeVerFerramentas ? [{ label: 'Ferramentas', to: '/ferramentas' }] : []),
                  ]}
                />
              )}
              {vendedorComercialInterno(profile) && (
                <DropdownNavItem
                  label="Solicitações"
                  active={isPathActive('/tarefas/solicitacoes')}
                  items={[{ label: 'Central de Solicitações', to: '/tarefas/solicitacoes' }]}
                />
              )}
              {!isEmpresaParceira && !isExternoGeradoras && profile?.role !== 'vendedor' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro' && (
                <DropdownNavItem
                  label="Projetos e Tarefas"
                  active={isPathActive('/tarefas') || isPathActive('/projetos')}
                  items={[
                    { label: 'Projetos', to: '/projetos' },
                    { label: 'Atividades e Visitas (CRM)', to: '/tarefas' },
                    ...(profile?.role !== 'motoboy' ? [{ label: 'Central de Solicitações', to: '/tarefas/solicitacoes' }] : []),
                  ]}
                />
              )}
              {(profile?.role === 'adm' || profile?.role === 'gerente' || profile?.permissions?.includes('modulo:geradoras')) && (
                <NavItem to="/geradoras" label="Geradoras" active={isPathActive('/geradoras')} />
              )}
              {!isExternoGeradoras && (isEmpresaParceira || (profile?.role !== 'vendedor' && profile?.role !== 'parceiro' && profile?.role !== 'vendedor_parceiro' && profile?.role !== 'gerente_parcerias' && profile?.role !== 'motoboy')) && (
                <DropdownNavItem
                  label="Financeiro"
                  active={isPathActive('/financeiro')}
                  items={[
                    { label: 'Dashboard', to: '/financeiro' },
                    ...(profile?.role === 'adm' ? [{ label: 'Painel Executivo', to: '/financeiro/painel-executivo' }] : []),
                    { label: 'UCs / Clientes', to: '/financeiro/ucs' },
                    { label: 'Faturas e Cobranças', to: '/financeiro/faturas' },
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Conferência do Faturamento', to: '/financeiro/conferencia-faturamento' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Recebimento de Faturas', to: '/financeiro/recebimento-faturas' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Agrupamentos de Faturamento', to: '/financeiro/agrupamentos-faturamento' }] : []),
                    { label: 'Parcelamentos', to: '/financeiro/parcelamentos' },
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Previsão de Recebíveis', to: '/financeiro/previsao-recebiveis' }] : []),
                    /* Folha de Pagamento oculta do menu a pedido — a rota /financeiro/folha-pagamento
                       continua ativa e acessivel por link direto. Para trazer de volta, descomente a linha abaixo. */
                    // ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Folha de Pagamento', to: '/financeiro/folha-pagamento' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Lembretes de Cobrança', to: '/financeiro/lembretes-cobranca' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Rota de Cobrança', to: '/financeiro/rota-cobranca' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Painel de Cobrança e Documentos', to: '/financeiro/esteira' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Sincronização de Status', to: '/financeiro/sincronizacao-status' }] : []),
                    ...((profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'analista') ? [{ label: 'Cancelamentos', to: '/financeiro/cancelamentos' }] : []),
                    { label: 'Inadimplência', onClick: () => { setInadimplenciaInitialTab(undefined); setShowInadimplenciaDashboard(true); } }
                  ]}
                />
              )}
              {/* Academy: o Minicurso do Parceiro (vídeos, resumos, PDFs e calculadora de comissão). */}
              {podeVerAcademy && <NavItem to="/academy" label="Academy" active={isPathActive('/academy')} />}
              {/* Quem entra no Omnichannel vem de `inbox_members`, nao de profile.role:
                  e a mesma lista que a RLS do banco consulta, entao liberar alguem
                  e uma linha na tabela em vez de um deploy. */}
              {ehMembroInbox && (
                <DropdownNavItem
                  label="Inbox"
                  active={isPathActive('/inbox') || isPathActive('/omnichannel')}
                  items={papelInbox === 'observador' ? [
                    // #6530: observador (gerente do Comercial) só acompanha as conversas.
                    { label: 'Caixa de entrada', to: '/inbox' },
                    { label: 'Atendimento', to: '/inbox/atendimento' },
                  ] : [
                    { label: 'Caixa de entrada', to: '/inbox' },
                    { label: 'Conexões', to: '/inbox/configuracoes' },
                    { label: 'Atendimento', to: '/inbox/atendimento' },
                    { label: 'Automação', to: '/inbox/fluxos' },
                    { label: 'Integrações', to: '/inbox/eventos' },
                    { label: 'Acompanhamento', to: '/omnichannel' }
                  ]}
                />
              )}
            </div>

            {/* Icons & Actions - Right */}
            <div className="hidden lg:flex items-center gap-4">
              {/* Ativa/Inativa do SLA — só aparece pra quem tem SLA medido
                  (Closers e BDRs); o próprio componente decide. */}
              <PausaSlaToggle />

              <ThemeToggle />

              <NotificationDropdown />

              {(profile?.role === 'adm' || profile?.role === 'gerente' || profile?.role === 'parceiro' || profile?.role === 'gerente_parcerias' || profile?.role === 'empresa_parceira_admin') && (
                <Link to="/config" className={`text-gray-500 hover:text-primary p-2 rounded-full hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 transition-colors ${isPathActive('/config') ? 'text-primary bg-gray-100 dark:bg-gray-700' : ''}`}>
                  <Settings size={20} />
                </Link>
              )}


              <div className="h-6 w-[1px] bg-gray-200 dark:bg-gray-700 mx-1"></div>

              <div className="relative flex items-center ml-1" ref={profileDropdownRef}>
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
                >
                  {/* Reusing existing profile visual logic but maybe simplifying for top bar if needed, keeping it as is for now */}
                  <div className="text-right hidden xl:block">
                    {/* Optional: could hide text on smaller md screens if space is tight */}
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 leading-none">{profile?.full_name?.split(' ')[0] || user?.email?.split('@')[0]}</p>
                  </div>
                  <img
                    src={profile?.avatar_url || 'https://via.placeholder.com/40'}
                    alt="Avatar"
                    className="w-9 h-9 rounded-full border-2 border-primary/20 p-0.5 object-cover"
                    onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/40')}
                  />
                </div>

                {profileDropdownOpen && (
                  <div className="absolute right-0 top-full mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 border border-gray-200 dark:border-gray-700 z-50">
                    {!isExternoGeradoras && (
                      <Link
                        to="/config/profile"
                        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full text-left"
                        onClick={() => setProfileDropdownOpen(false)}
                      >
                        <User size={16} />
                        Conta & Perfil
                      </Link>
                    )}
                    <button
                      onClick={() => {
                        setProfileDropdownOpen(false);
                        signOut();
                      }}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700 w-full text-left transition-colors"
                    >
                      <LogOut size={16} />
                      Sair
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="flex items-center lg:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
              >
                <span className="sr-only">Open main menu</span>
                {mobileMenuOpen ? (
                  <X className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <Menu className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu — barra lateral (drawer) */}
        {mobileMenuOpen && (
          <div className="lg:hidden fixed inset-0 z-50 flex justify-end">
            <div className="fixed inset-0 bg-black/40" onClick={() => setMobileMenuOpen(false)}></div>
            <div className="relative flex flex-col w-72 max-w-[80%] h-full bg-white dark:bg-gray-800 shadow-xl animate-slide-in-right overflow-y-auto">
              <div className="flex items-center justify-between px-4 h-16 border-b border-gray-200 dark:border-gray-700 shrink-0">
                <img src="/vigorhub_logo_transparent.png" alt="VigorHub Logo" className="h-9 object-contain" />
                <button
                  onClick={() => setMobileMenuOpen(false)}
                  className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <div className="flex-1 pt-2 pb-3 space-y-1 px-2">
                {/* Mesmo botão Ativa/Inativa do header — no mobile ele precisa
                    estar aqui, senão a barra de cima só tem o menu. */}
                <div className="px-2 pb-2 empty:hidden">
                  <PausaSlaToggle mostrarRotulo />
                </div>
                {!isEmpresaParceira && !isExternoGeradoras && profile?.role !== 'motoboy' && (
                  <Link
                    to="/crm?novaNegociacao=1"
                    // O drawer fecha sozinho na troca de pathname, mas quem já está
                    // em /crm só muda a query — o menu ficaria aberto por trás do wizard.
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center justify-between gap-2 px-4 py-3.5 mb-3 rounded-xl font-bold text-white bg-secondary hover:bg-secondary/90 transition-colors shadow-lg shadow-secondary/20"
                  >
                    <span className="flex items-center gap-2">
                      <Plus size={18} />
                      Nova Negociação
                    </span>
                    <ArrowRight size={18} />
                  </Link>
                )}
                {/* Cada módulo com 2+ telas vira acordeão (MobileNavGroup); com 1 só,
                    renderMobileModule devolve um link direto — sem cabeçalho pra clicar
                    à toa. Ver construção dos arrays mobileXxxItems acima do return. */}
                {renderMobileModule('dashboard', LayoutDashboard, 'Dashboard', mobileDashboardItems)}
                {renderMobileModule('marketing', Megaphone, 'Marketing', mobileMarketingItems)}
                {renderMobileModule('crm', KanbanSquare, 'CRM', mobileCrmItems)}
                {renderMobileModule('gestao', PieChart, 'Gestão', mobileGestaoItems)}
                {renderMobileModule('projetos-tarefas', Briefcase, 'Projetos e Tarefas', mobileProjetosTarefasItems)}
                {podeVerGeradoras && (
                  <MobileNavItem to="/geradoras" icon={Zap} label="Geradoras" active={isPathActive('/geradoras')} />
                )}
                {renderMobileModule('financeiro', DollarSign, 'Financeiro', mobileFinanceiroItems)}
                {podeVerAcademy && <MobileNavItem to="/academy" icon={GraduationCap} label="Academy" active={isPathActive('/academy')} />}
                {renderMobileModule('omnichannel', MessageSquare, 'Inbox', mobileOmnichannelItems)}
              </div>
              <div className="pt-4 pb-4 border-t border-gray-200 dark:border-gray-700">
                <div className="flex items-center px-5">
                  <div className="flex-shrink-0">
                    <img
                      className="h-10 w-10 rounded-full object-cover"
                      src={profile?.avatar_url || 'https://via.placeholder.com/40'}
                      alt=""
                      onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/40')}
                    />
                  </div>
                  <div className="ml-3">
                    <div className="text-base font-medium leading-none text-gray-800 dark:text-gray-100">{profile?.full_name || user?.email}</div>
                    <div className="text-sm font-medium leading-none text-gray-500 dark:text-gray-400 mt-1">{profile?.job_title || profile?.role}</div>
                  </div>
                  <div className="ml-auto flex gap-2">
                    <Link to="/config/notifications" className="p-2 rounded-full text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                      <Bell size={20} />
                    </Link>
                    <Link to="/config" className="p-2 rounded-full text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                      <Settings size={20} />
                    </Link>
                  </div>
                </div>
                {/* O "Sair" do computador fica no menu da foto, que some no celular (#6139). */}
                <div className="px-2 mt-3">
                  <button
                    onClick={() => {
                      setMobileMenuOpen(false);
                      signOut();
                    }}
                    className="flex items-center gap-2 w-full px-3 py-2 rounded-md text-base font-medium text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  >
                    <LogOut size={18} />
                    Sair
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Main Content Area - Added top padding for fixed header */}
      <main className={`pt-16 min-h-screen ${isParceiroOrVendedorParceiro ? 'pb-16 md:pb-0' : ''}`}>
        <div className="w-full mx-auto py-6 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>

      {/* Pop-up de termo reprovado ao abrir o site (parceiro / vendedor_parceiro / vendedor) */}
      <TermoReprovadoPopup />

      {/* Modal de Solicitação — abre por cima de qualquer tela, sem navegar.
          Ver views/Tarefas/SolicitacaoModalGlobal.tsx e src/lib/abrirSolicitacao.ts */}
      <SolicitacaoModalGlobal />
      {/* #6355: popup de prazo das solicitações, em qualquer tela, só para o responsável. */}
      <AvisoPrazoSolicitacoes />
      <AvisosSolicitacao />

      {/* Pop-up de aprovação de desconto ao abrir o site (gerente / adm / gerente_parcerias) */}
      <AprovacaoDescontoPopup />

      {/* Pop-up de termo assinado aguardando análise cadastral (departamento Pós Venda) */}
      <TermoAssinadoPopup />

      {/* Pop-up de novo lead atribuído em tempo real (Closers e BDRs) */}
      <LeadAssignedPopup />

      {/* Central de Inadimplência - acessível pelo dropdown Financeiro ou por notificação de cobrança D+15 */}
      <InadimplenciaDashboard
        isOpen={showInadimplenciaDashboard}
        onClose={() => setShowInadimplenciaDashboard(false)}
        initialTab={inadimplenciaInitialTab}
      />
      {/* Vick — assistente de IA interna, disponível pro time interno (não pra parceiros externos) */}
      {podeVerVick && <VickLauncherButton />}

      {/* Barra inferior mobile — atalho pra Perfil e Dados Bancários (parceiro/vendedor_parceiro) */}
      {isParceiroOrVendedorParceiro && (
        <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex items-stretch">
          <Link
            to="/config/profile"
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 ${isPathActive('/config/profile') ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}`}
          >
            <User size={20} />
            <span className="text-[11px] font-medium">Perfil</span>
          </Link>
          <Link
            to="/config/financeiro"
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 ${isPathActive('/config/financeiro') ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}`}
          >
            <Wallet size={20} />
            <span className="text-[11px] font-medium">Financeiro</span>
          </Link>
          <Link
            to="/config/dados-bancarios"
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 ${isPathActive('/config/dados-bancarios') ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}`}
          >
            <CreditCard size={20} />
            <span className="text-[11px] font-medium">Bancário</span>
          </Link>
        </nav>
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          {/* Conta inativa não vê o app nem o portal: a plataforma responde "em manutenção" */}
          <MaintenanceGate>
          <Routes>
            <Route path="/login" element={<LoginView />} />
            <Route path="/apresentacao" element={<ApresentacaoView />} />
            {/* Acordo de parcelamento aberto pelo link do associado, sem login (#6204) */}
            <Route path="/acordo/:token" element={<AcordoPublicoView />} />
            <Route path="/manual-do-consumidor" element={<ManualConsumidorView />} />
            <Route path="/cadastro-consultor/:codigo" element={<CadastroConsultorView />} />
            {/* Link do parceiro para captar clientes, sem login (#6511) */}
            <Route path="/parceiro/:codigo" element={<LinkParceiroView />} />
            {/* Marca do portal (#6117): Vigor ou a da parceira (Gran), decidida pelo banco
                depois do login e pela URL antes dele. */}
            <Route element={<MarcaPortalLayout />}>
              <Route path="/portal-consumidor" element={<PortalConsumidorView />} />
              <Route path="/portal-consumidor/gran" element={<PortalConsumidorView />} />
              <Route path="/portal-consumidor/nova-senha" element={<PortalConsumidorNovaSenha />} />
              <Route element={<PortalConsumidorGate />}>
                <Route path="/portal-consumidor/inicio" element={<PortalConsumidorHome />} />
                <Route path="/portal-consumidor/perfil" element={<PortalConsumidorPerfil />} />
                <Route path="/portal-consumidor/faturas" element={<PortalConsumidorFaturas />} />
                <Route path="/portal-consumidor/parcelamentos" element={<PortalConsumidorParcelamentos />} />
                <Route path="/portal-consumidor/ajuda" element={<PortalConsumidorAjuda />} />
                <Route path="/portal-consumidor/antes-de-cancelar" element={<PortalConsumidorRetencao />} />
                <Route path="/portal-consumidor/cancelamento" element={<PortalConsumidorCancelamento />} />
              </Route>
            </Route>
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <ConsumidorPortalGate>
                  <ExternoGeradorasGate>
                  <AvisosSistemaGate>
                    <ExtracaoFaturasProvider>
                      <MainLayout>
                        <Routes>
                          <Route path="/" element={<VisaoGeralView />} />
                          <Route path="/dashboard/*" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'consumidor']} allowIf={ehGerenteComercial}><DashboardLayout /></RoleGuard>} />
                          <Route path="/gestao/*" element={<RoleGuard blocked={['vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'gerente', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador']} allowPermission="modulo:gestao" allowIf={ehGerenteComercial}><GestaoLayout /></RoleGuard>} />
                          <Route path="/financeiro/*" element={<RoleGuard blocked={['motoboy']}><FinanceiroLayout /></RoleGuard>} />
                          <Route path="/crm/*" element={<RoleGuard blocked={['empresa_parceira_admin', 'empresa_parceira_operador']}><CRMLayout /></RoleGuard>} />
                          <Route path="/tarefas" element={<RoleGuard blocked={['vendedor', 'parceiro', 'vendedor_parceiro', 'empresa_parceira_admin', 'empresa_parceira_operador']}><TarefasView /></RoleGuard>} />
                          {/* #6518: vendedor do Comercial pede e atende pela Central (Parcerias segue de fora). */}
                          <Route path="/tarefas/solicitacoes" element={<RoleGuard blocked={['vendedor', 'motoboy', 'parceiro', 'vendedor_parceiro', 'empresa_parceira_admin', 'empresa_parceira_operador']} allowIf={vendedorComercialInterno}><TarefasView fixedCategoria="solicitacao" /></RoleGuard>} />
                          {/* Projetos: agrupador das solicitações. Mesmo recorte de papéis da
                              Central de Solicitações — quem trabalha nas tarefas acompanha o
                              projeto. Criar/editar é só adm/gerente, checado na própria View e
                              pela RLS de projetos. */}
                          <Route path="/projetos" element={<RoleGuard blocked={['vendedor', 'parceiro', 'vendedor_parceiro', 'empresa_parceira_admin', 'empresa_parceira_operador']}><ProjetosView /></RoleGuard>} />
                          <Route path="/projetos/:id" element={<RoleGuard blocked={['vendedor', 'parceiro', 'vendedor_parceiro', 'empresa_parceira_admin', 'empresa_parceira_operador']}><ProjetoDetailView /></RoleGuard>} />
                          <Route path="/geradoras" element={<RoleGuard blocked={['empresa_parceira_admin', 'empresa_parceira_operador']}><GeradorasView /></RoleGuard>} />
                          {/* Vick em tela cheia: fila de alertas + conversa. Mesmo
                              recorte do botao flutuante — externos ficam de fora. */}
                          <Route path="/vick" element={<RoleGuard blocked={['vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><VickView /></RoleGuard>} />
                          {/* Ferramentas: lista de quem ENTRA (não de bloqueio), para papel novo
                              nascer sem acesso. Mesma régua de `podeVerFerramentas` no menu. */}
                          <Route path="/ferramentas/*" element={<RoleGuard allowed={['adm', 'gerente', 'analista']}><FerramentasLayout /></RoleGuard>} />
                          <Route path="/marketing/*" element={<RoleGuard blocked={['vendedor', 'parceiro', 'gerente_parcerias', 'vendedor_parceiro', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador']} allowPermission="modulo:marketing"><MarketingLayout /></RoleGuard>} />
                          <Route path="/academy" element={<RoleGuard blocked={['empresa_parceira_admin', 'empresa_parceira_operador']}><AcademyView /></RoleGuard>} />
                          {/* Acompanhamento do modulo Inbox Omnichannel: so 'adm'.
                              A autorizacao aqui e por bloqueio, entao todo papel que
                              nao seja 'adm' precisa estar listado.
                              A View refaz a checagem por dentro — hoje e defesa em
                              profundidade, nao remendo: o RoleGuard passou a falhar
                              FECHADO em 08/09, e perfil ausente ja nao entra. */}
                          <Route path="/omnichannel" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><OmnichannelView /></RoleGuard>} />
                          {/* Caixa de entrada (Fase 3). O RoleGuard e so a primeira
                              porta: quem decide de verdade e `inbox_members`, checado
                              dentro da propria View e pela RLS de cada tabela. */}
                          <Route path="/inbox" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']} allowIf={ehGerenteComercial}><InboxView /></RoleGuard>} />
                          <Route path="/inbox/configuracoes" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><InboxConfiguracoesView /></RoleGuard>} />
                          {/* Log de integracoes (Fase 8). Mesmo bloqueio: quem
                              decide de verdade e `inbox_members`, checado dentro
                              da View e pela RLS das duas tabelas. */}
                          <Route path="/inbox/eventos" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><InboxEventosView /></RoleGuard>} />
                          {/* Atendimento (Fase 14): etiquetas, respostas rapidas,
                              auditoria e o relatorio de primeira resposta. O
                              relatorio e visivel a qualquer membro; as outras
                              abas so a admin, checado por dentro. */}
                          <Route path="/inbox/atendimento" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']} allowIf={ehGerenteComercial}><InboxAtendimentoView /></RoleGuard>} />

                          {/* Automacao (Fases 10 e 11). Mesmo bloqueio das outras
                              rotas do modulo, e a porta de verdade continua sendo
                              `inbox_members` — as duas telas checam `ehAdmin` por
                              dentro, porque montar fluxo e decidir o que o sistema
                              escreve sozinho para o cliente. */}
                          <Route path="/inbox/fluxos" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><FluxosView /></RoleGuard>} />
                          <Route path="/inbox/fluxos/:flowId" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><EditorFluxoView /></RoleGuard>} />
                          {/* Composer minimo de validacao da Fase 5. Nao e a caixa
                              de entrada — essa e a Fase 3. Mesmo bloqueio do
                              /omnichannel: so 'adm' entra, porque enviar mensagem
                              daqui fala com o cliente de verdade. Sem item de menu
                              de proposito: e ferramenta de verificacao, nao tela de
                              operacao. */}
                          <Route path="/omnichannel/composer" element={<RoleGuard blocked={['gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy', 'empresa_parceira_admin', 'empresa_parceira_operador', 'geradoras_externo', 'consumidor']}><ComposerTesteView /></RoleGuard>} />
                          <Route path="/config/*" element={<ConfigView />} />
                        </Routes>
                      </MainLayout>
                    </ExtracaoFaturasProvider>
                  </AvisosSistemaGate>
                  </ExternoGeradorasGate>
                  </ConsumidorPortalGate>
                </ProtectedRoute>
              }
            />
          </Routes>
          </MaintenanceGate>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
